module.exports = __webpack_public_path__ + "img/HZSg-HOn_400x400.02313304.jpg";